import { CustomNextPage } from '../lib/types';
import { bootstrap } from '../lib/bootstrap';
import AssignRfidCard from '../modules/Profile/AssignRfidCard';
import ProfileLayout from '../modules/Profile/ProfileLayout';

const AssignRfidCardPage: CustomNextPage<{
  statusCode?: number;
}> = props => {
  const { url, statusCode } = props;
  return (
    <ProfileLayout url={url} statusCode={statusCode}>
      {({ currentUser }) => {
        if (!currentUser) {
          return null;
        }
        return <AssignRfidCard />;
      }}
    </ProfileLayout>
  );
};

export default bootstrap(AssignRfidCardPage);
